<header
class="relative header w-full text-white flex items-center justify-between z-10 px-4 py-2 md:px-8 md:py-4 shadow-lg bg-gray-100 min-w-44">
<button (click)="toggleSidenav()"
  class="bg-orange-400 hover:bg-orange-500 text-white p-2 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-orange-500 transition ease-in-out duration-150 button-animate">
  <!-- Icono de menú actualizado -->
  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
    aria-label="Menu">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
  </svg>
</button>

<div class="flex items-center">
  <h2 class="text-lg font-semibold">
    <a [routerLink]="'dashboard'">
      <button class="btn">Billing Middleware</button>
    </a>
  </h2>
</div>

<div role="button" [matMenuTriggerFor]="userMenu" tabindex="0"
  class="cursor-pointer flex items-center space-x-3 hover:animate-pulse bg-orange-400 text-white p-2 rounded-lg shadow-md hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-700 transition ease-in-out duration-150 button-animate">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
    class="h-8 w-8 text-white hover:text-orange-200">
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
  <span class="hidden md:block">Mi Cuenta</span>
</div>


<mat-menu #userMenu="matMenu" class="mr-4 bg-white rounded-lg shadow-lg divide-y divide-gray-100">
  <div class="flex items-center p-4 gap-4">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-orange-500" viewBox="0 0 24 24">
      <path
        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zm0-19c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 15c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z" />
    </svg>
    <div *ngIf="userInfo" class="flex flex-col">
      <p class="text-gray-800 text-sm font-semibold">{{ userInfo }}</p>
      <p class="text-gray-400 text-xs">{{ userRole }}</p>
    </div>
  </div>

  <div *ngIf="isLoading" class="flex justify-center items-center py-4">
    <mat-spinner diameter="35" strokeWidth="3" class="animate-spin"></mat-spinner>
  </div>

  <div class="py-1">
    <button mat-menu-item (click)="openUserFormModal()"
      class="flex items-center w-full p-3 hover:bg-orange-100 text-orange-700 transition-colors duration-150 rounded-md button-animate">
      <i class="fas fa-lock text-orange-500 hover:text-orange-700 mr-3"></i>
      <span>Cambiar contraseña</span>
    </button>
    <button mat-menu-item (click)="handleLogout()"
      class="flex items-center w-full p-3 hover:bg-orange-100 text-orange-700 transition-colors duration-150 rounded-md button-animate">
      <i class="fas fa-sign-out-alt text-orange-500 hover:text-orange-700 mr-3"></i>
      <span>Cerrar sesión</span>
    </button>
  </div>



</mat-menu>


</header>
